/**
 * defa.collections.Customers
 * A Collection of Customers with custom filters.
 * @version 1.2.0
 */
import Customer from 'scripts/defa/customers/model-customer';

const Customers = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model     : Customer,
	comparator: function ( model ) {
		return model.name();
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new Customers collection filtered by an array of ids.
	 * @param  {array}      ids  An array of ids to filter the collection by.
	 * @return {collection}      The filtered CustomerCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( customer ) {
			return _.contains( ids, customer.get( 'id' ) );
		} );
		
		return new Customers( array );
	},
	
	/**
	 * Returns a new Customers collection filtered by an array of roles.
	 * @param  {array}      roles  An array of roles to filter the collection by.
	 * @return {collection}        The filtered CustomerCollection.
	 */
	filterByRoles: function ( roles ) {
		let array = this.filter( function ( customer ) {
			return ( customer.hasRoles( roles ) );
		} );
		
		return new Customers( array );
	},
	
} );

export default Customers;